// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Medication field config from database.
 * @see #/components/schemas/MedicationCategoryFieldConfig - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MedicationCategoryFieldConfig {
    /**
     * Whether required for display.
     *
     */
    required_display: boolean;
    /**
     * Whether required for create.
     *
     */
    required_create: boolean;
    /**
     * Whether required for update.
     *
     */
    required_update: boolean;
    /**
     * Whether required for administration.
     *
     */
    required_administration: boolean;
    /**
     * Whether required in forms.
     *
     */
    required_form?: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MedicationCategoryFieldConfig
 */
export namespace MedicationCategoryFieldConfig {
    /**
     * MedicationCategoryFieldConfig Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Whether required for display.
         * @type boolean (`dataFormat` is missing)
         */
        requiredDisplay: boolean;
        /**
         * Whether required for create.
         * @type boolean (`dataFormat` is missing)
         */
        requiredCreate: boolean;
        /**
         * Whether required for update.
         * @type boolean (`dataFormat` is missing)
         */
        requiredUpdate: boolean;
        /**
         * Whether required for administration.
         * @type boolean (`dataFormat` is missing)
         */
        requiredAdministration: boolean;
        /**
         * Whether required in forms.
         * @type boolean (`dataFormat` is missing)
         */
        requiredForm?: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MedicationCategoryFieldConfig DTO
     * Transforms MedicationCategoryFieldConfig model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MedicationCategoryFieldConfig model */
        static toModel(obj: MedicationCategoryFieldConfig): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MedicationCategoryFieldConfig model */
        static toApi(obj: Model): MedicationCategoryFieldConfig {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MedicationCategoryFieldConfig;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
